<ng-container *ngIf="rowVm | method: 'getListItemsForColumnType' : sectionColumnType : displayFormat as listItems">
  <div #listgrid class="list-grid-container grid-layout" [ngClass]="[columnListLayoutModifierClass ?? '']">
    <div
      *ngFor="let listItem of listItems"
      class="list-grid-item"
      [class.has-list-grid-text-item]="this | method: 'listItemIsString' : listItem">
      <app-handle-badge-mode
        [rowVm]="rowVm"
        [colVm]="colVm"
        [listColumnBadgeAsset]="this | method: 'narrowListItemTypeToBadgeAsset' : listItem">
        <span class="list-grid-text-item">
          {{ this | method: 'narrowListItemTypeToString' : listItem }}
        </span>
      </app-handle-badge-mode>
    </div>
  </div>
</ng-container>
